/**
 * Utilitaires de formatage
 */

/**
 * Formate une taille en octets en une chaîne lisible avec l'unité appropriée (Ko, Mo, Go, To)
 * @param {number} bytes - Taille en octets
 * @param {number} decimals - Nombre de décimales (par défaut 2)
 * @returns {string} Taille formatée avec unité (ex: "1.5 Mo", "500 Ko", "2.3 Go")
 */
export const formatBytes = (bytes, decimals = 2) => {
  if (!bytes || bytes === 0) return '0 Ko';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['octets', 'Ko', 'Mo', 'Go', 'To'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // Si c'est moins de 1 Ko, on affiche en Ko avec décimales
  if (i === 0) {
    return `${(bytes / k).toFixed(dm)} Ko`;
  }

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

/**
 * Formate un nombre avec des espaces comme séparateurs de milliers
 * @param {number} num - Nombre à formater
 * @returns {string} Nombre formaté (ex: "1 234 567")
 */
export const formatNumber = (num) => {
  if (!num && num !== 0) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/**
 * Formate une date en format français
 * @param {string|Date} date - Date à formater
 * @returns {string} Date formatée (ex: "12/01/2024")
 */
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR').format(d);
};

/**
 * Formate une date et heure en format français
 * @param {string|Date} date - Date à formater
 * @returns {string} Date et heure formatées (ex: "12/01/2024 à 14:30")
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
};
